import { qs } from "./Selector"

const loadingBg = qs(".mini-cart .loading-bg")

export const formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "")
  }
  var value = ""
  var placeholderRegex = /{{\s*(\w+)\s*}}/
  var formatString = format || this.money_format
  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ",")
    decimal = defaultOption(decimal, ".")
    if (isNaN(number) || number == null) {
      return 0
    }
    number = (number / 100.0).toFixed(precision)
    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : ""
    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2)
      break
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0)
      break
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",")
      break
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",")
      break
  }
  return formatString.replace(placeholderRegex, value)
}

export const buildCart = async updatePadding => {
  try {
    const res = await fetch("/cart.js") // get initial cart state
    const cart = await res.json()
    const cartContainer = document.querySelector("[data-cart] .mini-cart-content")

    if (!cartContainer) return

    if (cart.item_count === 0) {
      cartContainer.innerHTML = '<p class="mini-cart-empty">Cart is empty.</p>'
    } else {
      cartContainer.innerHTML = cart.items
        .map(
          (item, i) => `
        <div class="mini-cart-item -p6" data-item="${i + 1}">
          <div class="mini-cart-image">
            <img src="${item.image}" alt="" class="mini-cart-product-preview">
          </div>
          <div class="mini-cart-details">
            <p class="mini-cart-title">${item.product_title}</p>
          </div>
          <div class="mini-cart-price">${formatMoney(item.price, Shopify.money_format)} x ${item.quantity}</div>
          <div class="mini-cart-quantity -p0" data-line="${i + 1}">
            <button class="btn -p0" data-type="minus">-</button>
            <span >${item.quantity}</span>
            <button class="btn -p0" data-type="plus">+</button>
          </div>
          <span class="mini-cart-remove" data-line="${i + 1}">Remove</span>
        </div>
      `
        )
        .join("")
    }

    document.querySelector("#mini-cart-total").textContent = formatMoney(cart.total_price, Shopify.money_format)
    document.querySelector("#mini-cart-item-count").textContent = cart.item_count
    updateMiniCartPadding()
    wireCartEvents() // Re-bind all events after DOM update
  } catch (err) {
    console.error("Failed to build cart:", err)
  }
}

const updateMiniCartPadding = () => {
  const miniCartContent = qs(".mini-cart-content")

  if (miniCartContent.scrollHeight >= window.innerHeight * 0.7) {
    miniCartContent.classList.add("scroll")
  } else {
    miniCartContent.classList.remove("scroll")
  }
}
const changeQuantity = async (line, quantity) => {
  loadingBg.classList.add("loading-bg_active")

  let response = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line, quantity }),
  })

  response = await response.json()

  if (response.status === 422) {
    console.log("Maximal quantity reached")
  }
  setTimeout(() => {
    loadingBg.classList.remove("loading-bg_active")
  }, 200)

  buildCart()
}

const removeItem = async line => {
  loadingBg.classList.add("loading-bg_active")

  await changeQuantity(line, 0)
}

export const wireCartEvents = () => {
  document.querySelectorAll("[data-line]").forEach(container => {
    const line = parseInt(container.dataset.line, 10)

    const minusBtn = container.querySelector('[data-type="minus"]')
    const plusBtn = container.querySelector('[data-type="plus"]')

    if (minusBtn) {
      minusBtn.onclick = () => {
        const currentQty = parseInt(container.querySelector("span").textContent, 10)
        if (currentQty > 1) {
          changeQuantity(line, currentQty - 1)
        }
      }
    }

    if (plusBtn) {
      plusBtn.onclick = () => {
        const currentQty = parseInt(container.querySelector("span").textContent, 10)
        changeQuantity(line, currentQty + 1)
      }
    }
  })

  document.querySelectorAll(".mini-cart-remove").forEach(btn => {
    const line = parseInt(btn.dataset.line, 10)
    btn.onclick = () => removeItem(line)
  })
}
